import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useTranslation } from '../context/LanguageContext';
import { getFooterPolicyLinks } from '../data/policyContent';
import './Footer.css';

const FOOTER_GROUPS = [
  {
    title: 'Legal',
    slugs: ['terms', 'privacy', 'disclaimer'],
  },
  {
    title: 'Policies',
    slugs: ['refund-policy', 'service-delivery-policy', 'pricing-payment-policy'],
  },
  {
    title: 'Company',
    slugs: ['about', 'contact', 'careers'],
  },
];

function getFooterLinksGrouped() {
  const all = getFooterPolicyLinks();
  const findLink = (slug) => {
    if (slug === 'contact') return all.find((l) => l.to === '/contact');
    if (slug === 'careers') return all.find((l) => l.to === '/careers');
    return all.find((l) => l.to === `/legal/${slug}`);
  };
  return FOOTER_GROUPS.map(({ title, slugs }) => ({
    title,
    links: slugs.map(findLink).filter(Boolean),
  })).filter((g) => g.links.length > 0);
}

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const isFAQPage = location.pathname === '/faq';
  const isContactPage = location.pathname === '/contact';
  const isGetStartedPage = location.pathname === '/get-started';
  const isReferralPage = location.pathname?.includes('/referral');
  const linkGroups = getFooterLinksGrouped();

  return (
    <footer className="footer">
      {!isFAQPage && !isContactPage && !isGetStartedPage && (
        <div className="footer-banner">
          <div className="container">
            {isReferralPage ? (
              <div className="banner-content referral-banner-content">
                <div className="banner-text-content">
                  <h2>Start Your Referral Partnership</h2>
                  <p>Join our partner network and earn competitive commissions while providing exclusive benefits to your clients</p>
                </div>
                <div className="banner-buttons">
                  <Link
                    to="/pricing/website-packages"
                    className="banner-button primary"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Register as Website Owner
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </Link>
                  <Link to="/contact" className="banner-button secondary">
                    Have Questions?
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </Link>
                </div>
              </div>
            ) : (
              <div className="banner-content">
                <h2>{t('footer.readyToGetStarted')}</h2>
                <button className="banner-button" onClick={() => navigate('/contact')}>
                  {t('footer.getStarted')}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="footer-links-bar">
        <div className="container container--footer">
          <div className="footer-links-grid">
            {linkGroups.map((group) => (
              <div key={group.title} className="footer-links-column">
                <h3 className="footer-column-title">{group.title}</h3>
                <ul className="footer-links-list">
                  {group.links.map(({ to, label }) => (
                    <li key={to}>
                      <Link to={to} className="footer-link" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container container--footer">
          <div className="footer-bottom-content">
            <p className="footer-copyright">All Rights Reserved © {new Date().getFullYear()}</p>
            <p className="footer-credit">Research, Designed and Developed by <span className="footer-brand">ApkaKhata</span></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

